import useWebSocket from 'react-use-websocket';

import { LastWebsocketJsonMessageType } from '@interfaces/webSocketConnectionInfo';

import { useGetWebsocketMsg } from '@core/dashboard/components/DashboardContent/hooks';
import { useHandleWebsocketMsg } from './hooks';

import { useMytaverse } from '@providers/MytaverseProvider';

const DashboardWebsocket = () => {
  const { activeSocketUrl, getWebSocketOptions } = useMytaverse();

  const getWebsocketMsg = useGetWebsocketMsg();

  const { lastJsonMessage } = useWebSocket(
    activeSocketUrl,
    getWebSocketOptions({ withReconnection: false }),
  );

  const websocketMsg = getWebsocketMsg(
    lastJsonMessage as LastWebsocketJsonMessageType,
  );

  useHandleWebsocketMsg(websocketMsg);

  return null;
};

export default DashboardWebsocket;
